(function () {
  'use strict';
  if (window.KnickerProductOptions) return;
  function key(value) { return String(value).indexOf('option') === 0 ? String(value) : 'option' + value; }
  function matching(product, options) {
    var matches = product.variants.filter(function (variant) {
      return Object.keys(options).every(function (name) { return !options[name] || variant[name] === options[name]; });
    });
    if (Object.keys(options).some(function (name) { return !options[name]; })) return matches.find(function (variant) { return variant.available; }) || matches[0];
    return matches[0];
  }
  function updateUrl(model) {
    var previous = new URL(window.location.href);
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var path = model.product.url || (model.product.handle ? root + 'products/' + model.product.handle : previous.pathname);
    var url = new URL(path, previous.origin);
    url.search = previous.search;
    url.hash = previous.hash;
    if (!model.size_option_key || model.size_chosen) url.searchParams.set('variant', model.current_variant.id);
    else url.searchParams.delete('variant');
    window.history.replaceState(null, '', url.toString());
    document.dispatchEvent(new CustomEvent('knicker:product-change', { detail: { id: model.product.id } }));
  }
  function updateVariant(model) {
    var sizeKey = model.size_option_key;
    if (sizeKey && model.options) {
      model.options[sizeKey] = model.product.variants.map(function (variant) { return variant[sizeKey]; }).filter(function (value, index, values) { return values.indexOf(value) === index; });
    }
    var variant = matching(model.product, model.selected_options);
    if (!variant && sizeKey) {
      model.selected_options[sizeKey] = '';
      model.size_chosen = false;
      model.size_notice = 'Your size is not available in this colour. Please choose another size.';
      variant = matching(model.product, model.selected_options);
    }
    model.current_variant = variant || model.product.variants.find(function (item) { return item.available; }) || model.product.variants[0];
    if (sizeKey && model.size_chosen && !model.current_variant.available) model.size_notice = 'This size is sold out in this colour. Please choose another size.';
    updateUrl(model);
  }
  window.KnickerProductOptions = {
    handleOption: function (model, option, value) {
      var optionKey = key(option);
      model.selected_options[optionKey] = value;
      model.size_notice = '';
      if (optionKey === model.size_option_key) model.size_chosen = Boolean(value);
      if (optionKey === 'option1' && model.colour_products && model.colour_products[value]) model.product = model.colour_products[value];
      updateVariant(model);
    },
    updateVariant: updateVariant,
    updateUrl: updateUrl,
    unavailable: function (model, option, value) {
      var options = Object.assign({}, model.selected_options);
      options[key(option)] = value;
      return !model.product.variants.some(function (variant) {
        return variant.available && Object.keys(options).every(function (name) { return !options[name] || variant[name] === options[name]; });
      });
    },
    requireSize: function (model) {
      if (!model.size_option_key || (model.size_chosen && model.selected_options[model.size_option_key])) return true;
      model.size_notice = 'Please choose your size before adding to your bag.';
      var select = model.$el && model.$el.querySelector('[data-product-size-select]');
      if (select) { select.scrollIntoView({ block: 'center', behavior: 'smooth' }); select.focus({ preventScroll: true }); }
      return false;
    }
  };
})();
